import { useNavigate } from 'react-router-dom';
import { BookOpen, Clock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { type ProtocolInfo } from '@/hooks/useDashboardData';

interface ProtocolHighlightCardProps {
  protocol: ProtocolInfo;
}

const ProtocolHighlightCard = ({ protocol }: ProtocolHighlightCardProps) => {
  const navigate = useNavigate();

  const isComplete = protocol.totalCompleted >= 21;

  return (
    <div className="bg-card rounded-2xl p-5 shadow-card border border-border relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-full blur-2xl -mr-6 -mt-6 pointer-events-none" />

      <div className="relative z-10">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-secondary flex items-center justify-center">
              <BookOpen className="h-4 w-4 text-primary" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Tu protocolo</p>
              <p className="text-sm font-semibold">
                {isComplete ? '¡Protocolo completado!' : `Día ${protocol.currentDay} de 21`}
              </p>
            </div>
          </div>
          {!isComplete && protocol.estimatedMinutes > 0 && (
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {protocol.estimatedMinutes} min
            </span>
          )}
        </div>

        {!isComplete && (
          <>
            <h3 className="text-base font-heading font-semibold mb-1">{protocol.dayTitle}</h3>
            <p className="text-xs text-muted-foreground leading-relaxed mb-4 line-clamp-2">
              {protocol.objective}
            </p>
          </>
        )}

        {isComplete && (
          <p className="text-sm text-muted-foreground mb-4">
            Has completado los 21 días. ¡Felicidades por tu compromiso!
          </p>
        )}

        <Button
          size="sm"
          className="w-full rounded-xl"
          onClick={() => navigate('/app/protocolo')}
        >
          {isComplete ? 'Revisar protocolo' : 'Continuar protocolo'}
          <ArrowRight className="h-3.5 w-3.5 ml-1" />
        </Button>
      </div>
    </div>
  );
};

export default ProtocolHighlightCard;
